import { render, staticRenderFns } from "./DealerReviews.vue?vue&type=template&id=55aa6e72&scoped=true"
import script from "./DealerReviews.vue?vue&type=script&lang=js"
export * from "./DealerReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa6e72",
  null
  
)

export default component.exports